<div class="form-group mb-3">
    <input #filterBox type="text" class="form-control" [placeholder]="this.getPlaceHolderTemplate()" [title]="this.getPlaceHolderToolTipTemplate()"
        (keyup)="filter($event)" (paste)="onPaste($event)" />
</div>

<table class="table table-striped table-hover table-sm table-max-width">
  <thead>
    <tr>
      <th
        appResizableColumn
        style="cursor: pointer;"
        [columnIndex]="0"
        storageKey="itemsTable:code"
      >
        <a (click)="sortBy('code')" style="cursor: pointer;">Code {{sortIcon('code')}}</a>
      </th>

      <th
        appResizableColumn
        style="cursor: pointer;overflow: hidden; text-overflow: ellipsis;white-space: nowrap"
        [columnIndex]="1"
        storageKey="itemsTable:name"
      >
        <a (click)="sortBy('name')" style="cursor: pointer;">Name {{sortIcon('name')}}</a>
      </th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let item of pageOfItems">
      <td (click)="select(item.code, item.name)" style="cursor: pointer;overflow: hidden; text-overflow: ellipsis;white-space: nowrap">{{ item.code }}</td>
      <td (click)="select(item.code, item.name)" style="cursor: pointer;overflow: hidden; text-overflow: ellipsis;white-space: nowrap">{{ item.name }}</td>
    </tr>

    <tr *ngIf="loading">
      <td colspan="5" class="text-center py-5">
        <app-loading />
      </td>
    </tr>

    <tr *ngIf="items.length === 0">
      <td colspan="5" class="text-center py-5">
        There are no items for current filter
      </td>
    </tr>
  </tbody>
</table>

<div *ngIf="items.length>0" class="card-footer text-center">
    <pagination [items]="items" (changePage)="onChangePage($event)"></pagination>
</div>
